import Widget from "../../lib/ui/Widget";
import { C } from "../../lib/ui/constructors";
import { PathEditor } from "../pathedit/PathEditor";
import { GameLayer } from "../../lib/gamemap/GameLayer";
import TheoryCrafter from "./theorycrafting/TheoryCrafter";
import Button from "../../lib/ui/controls/Button";
import MapUtilityBehaviour from "./MapUtilityBehaviour";
import { observe } from "../../lib/reactive";
import Behaviour from "../../lib/ui/Behaviour";
import ClueSolvingBehaviour from "../cluesolving/ClueSolvingBehaviour";
import Properties from "./widgets/Properties";
import { SettingsModal } from "./settings/SettingsEdit";
import { AboutModal } from "../AboutModal";
import { Alt1Modal } from "../Alt1Modal";
import { HoverTileDisplay } from "./devutilitylayer/UtilityLayer";
import { ClueTrainerWiki } from "../wiki";
import { Path } from "../../lib/runescape/pathing";
var spacer = C.spacer;
var span = C.span;
var movement_state = Path.movement_state;
class MenuButton extends Button {
    constructor(name, icon) {
        super();
        this.addClass("ctr-menubar-button");
        this.append(c("<div style='height: 32px'></div>").append(c(`<img src="${icon}" style="width: 32px" alt="">`)), span(name));
    }
    setActive(v) {
        this.toggleClass("active", v);
        return this;
    }
}
export class SimpleMapBehaviour extends Behaviour {
    constructor(app) {
        super();
        this.app = app;
        this.layer = new GameLayer();
        this.layer.add(new HoverTileDisplay());
    }
    begin() {
        this.app.map.addGameLayer(this.layer);
    }
    end() {
        this.layer.remove();
    }
}
export default class MainTabControl extends Widget {
    constructor(app) {
        super();
        this.app = app;
        this.active_tab = observe(null);
        this.addClass("ctr-menubar");
        this.append(this.solve_button = new MenuButton("Solve", "/assets/icons/ribbon_clue.png")
            .onClick(() => {
            this.switchToTab("solve");
        })
            .addTippy(new Properties().header("Clue Solver")
            .row(c().text("Clue solver to use while solving or for looking at methods.").css("font-style", "italic")), {
            placement: "right",
            hideOnClick: false
        }), this.map_button = new MenuButton("Map", "/assets/icons/ribbon_map.png")
            .onClick(() => {
            this.switchToTab("map");
        })
            .addTippy(new Properties().header("Map")
            .row(c().text("A simple map view.").css("font-style", "italic")), {
            placement: "right",
            hideOnClick: false
        }), this.create_button = new MenuButton("Methods", "/assets/icons/ribbon_notes.webp")
            .onClick(() => {
            this.switchToTab("create");
        })
            .addTippy(new Properties().header("Method Management")
            .row(c().text("View, Manage and Create methods for clue steps.").css("font-style", "italic")), {
            placement: "right",
            hideOnClick: false
        }), this.paths_button = new MenuButton("Paths", "/assets/icons/ribbon_activitytracker.webp")
            .onClick(() => {
            this.switchToTab("pathedit");
        })
            .addTippy(new Properties().header("Path Editor")
            .row(c().text("Edit paths on the map independently of clues.").css("font-style", "italic")), {
            placement: "right",
            hideOnClick: false
        }), this.tetracompass_button = new MenuButton("Tetras", "/assets/icons/ribbon_tetra.png")
            .onClick(() => {
            this.switchToTab("tetracompass");
        })
            .addTippy(new Properties().header("Tetracompass Solver")
            .row(c().text("The compass solver adapted to work for tetracompasses.").css("font-style", "italic")), {
            placement: "right",
            hideOnClick: false
        }), spacer(), this.app.in_alt1 ? undefined :
            new MenuButton("Alt1", "/assets/icons/ribbon_alt1.png")
                .onClick(() => {
                new Alt1Modal().show();
            })
                .setActive(true)
                .addTippy(new Properties().header("Alt 1")
                .row(c().text("Shows instructions how to add Clue Trainer to Alt1.").css("font-style", "italic")), {
                placement: "right",
                hideOnClick: false
            }), new MenuButton("Wiki", "/assets/icons/ribbon_osh.png")
            .onClick(() => ClueTrainerWiki.openOnPage())
            .setActive(true)
            .addTippy(new Properties().header("Cluepedia")
            .row(c().text("Cluepedia is a mini wiki included with Clue Trainer that contains guides and explanations of clue mechanics.").css("font-style", "italic")), {
            placement: "right",
            hideOnClick: false
        }), this.settings_button = new MenuButton("Settings", "/assets/icons/ribbon_options.webp").onClick(() => {
            SettingsModal.openOnPage();
        })
            .setActive(true)
            .addTippy(new Properties().header("Settings")
            .row(c().text("Access settings.").css("font-style", "italic")), {
            placement: "right",
            hideOnClick: false
        }), new MenuButton("About", "/assets/icons/ribbon_about.webp")
            .setActive(true)
            .onClick(() => [
            new AboutModal().show()
        ]), c().append(c(`<a href="https://github.com/Leridon/cluetrainer" target="_blank"> <img class="ctr-clickable" height="15px" style="padding: 0 2px" src="/assets/icons/github-mark-white.png"></a>`), c(`<a href="https://ko-fi.com/I2I4XY829" target="_blank"><img class="ctr-clickable" height="15px" src="/assets/icons/kofi.webp"></a>`)), c().append());
        this.updateState();
        // Solving (Clue Icon)
        // Method Editor (including overview map)
        // Path Editor  (Path Icon)
        // Shortcut Editor (Shortcut Icon)
        // Settings
    }
    switchToTab(tab) {
        if (tab == this.active_tab.value())
            return;
        switch (tab) {
            case "map":
                this.app.main_behaviour.set(new SimpleMapBehaviour(this.app));
                break;
            case "solve":
                this.app.main_behaviour.set(new ClueSolvingBehaviour(this.app, false));
                break;
            case "tetracompass":
                this.app.main_behaviour.set(new ClueSolvingBehaviour(this.app, true));
                break;
            case "create":
                this.app.main_behaviour.set(new TheoryCrafter(this.app));
                break;
            case "pathedit":
                this.app.main_behaviour.set(new PathEditor(new GameLayer().addTo(this.app.map), this.app.template_resolver, {
                    initial: [],
                    start_state: movement_state.start({ double_surge: true, double_escape: true, mobile_perk: true }),
                    editable_assumptions: true
                }, true));
                break;
            case "utility":
                this.app.main_behaviour.set(new MapUtilityBehaviour(this.app));
                break;
        }
        this.active_tab.set(tab);
        this.updateState();
    }
    updateState() {
        const active_tab = this.active_tab.value();
        this.solve_button?.setActive(active_tab == "solve");
        this.map_button?.setActive(active_tab == "map");
        this.create_button?.setActive(active_tab == "create");
        this.paths_button?.setActive(active_tab == "pathedit");
        this.utility_button?.setActive(active_tab == "utility");
        this.tetracompass_button?.setActive(active_tab == "tetracompass");
    }
    setCollapsed(v) {
        if (v)
            this.container.animate({ "width": "hide" }, 0);
        else
            this.container.animate({ "width": "show" }, 0);
    }
}
